import { Validators } from '@angular/forms';
import { IColumnConfigTableResponsive } from 'src/app/domain/IColumnConfigTableResponsive';
import { FieldTypeEnum } from 'src/app/domain/registration/enums/field-type.enum';
import { TableResponsiveTypeColumnEnum } from 'src/app/domain/registration/enums/table-responsive-type-column.enum';
import { TypeComponentFieldEnum } from 'src/app/domain/registration/enums/type-component-dynamic.enum';
import { SystemIndexSelectComponent } from '../systems/crud-index/crud-index-select.component';

export const RELATIVE_URL = 'system-modules';

export const COLUMNS_TO_SHOW_WEB = ['select', 'system', 'name','createdAt','actions'];
export const COLUMNS_TO_SHOW_MOBILE = COLUMNS_TO_SHOW_WEB;
export const TABLE_CONFIG_COLUMNS: IColumnConfigTableResponsive[] = [
  {
    field_type: FieldTypeEnum.LABEL,
    link_show: true,
    property: 'system',
    display: 'SISTEMA',
    class: TableResponsiveTypeColumnEnum.SUBTITLE,
  },
  {
    field_type: FieldTypeEnum.LABEL,
    link_show: true,
    property: 'name',
    display: 'NOME',
    class: TableResponsiveTypeColumnEnum.SUBTITLE,
  },
  {
    field_type: FieldTypeEnum.LABEL,
    link_show: true,
    property: 'createdAt',
    display: 'CRIADO EM',
    class: TableResponsiveTypeColumnEnum.SUBTITLE,
  },

];

export const CES_CONFIG_FIELDS = [
  {
    type: TypeComponentFieldEnum.HIDDEN,
    name: 'id',
  },
  {
    type: TypeComponentFieldEnum.SELECT_CRUD,
    label: 'Sistema',
    component: SystemIndexSelectComponent,
    name: 'system',
    value: 'name',
    defaultValue: ' ',
    options: [Object.values([])],
    placeholder: 'Selecione uma opção',
    validation: [Validators.required],
  },
  {
    type: TypeComponentFieldEnum.INPUT,
    label: 'NOME',
    name: 'name',
    placeholder: 'Insira o nome',
    validation: [Validators.required, Validators.minLength(4)],
  },
  {
    labelSave: 'Salvar',
    labelCancel: 'Cancelar',
    name: 'cancelSave',
    type: TypeComponentFieldEnum.CANCEL_SAVE,
  },
];
